import { Container, Graphics } from 'pixi.js';

export default class SegmentedHealthBar extends Container {
  #frame = new Graphics();
  #segmentGraphics = new Graphics();

  #health = 1;
  #background = 0x1f2937;
  readonly #width: number;
  readonly #height: number;
  readonly #segments: number;
  #padding = 2;
  #gap = 2;
  #radius = 7;

  constructor(width = 50, height = 16, segments = 10) {
    super();
    this.#width = width;
    this.#height = height;
    this.#segments = segments;

    this.pivot.set(this.#width / 2, this.#height);
    this.addChild(this.#frame, this.#segmentGraphics);
    this.redraw();
  }

  set health(v: number) {
    this.#health = Math.max(0, Math.min(1, v));
    this.redraw();
  }

  private redraw() {
    const color = this.#health <= 0.26 ? 0xb91e5d : this.#health <= 0.51 ? 0xd5c620 : 0x20b8b7;

    this.#frame
      .clear()
      .lineStyle(2, color, 0.9)
      .beginFill(this.#background, 0.6)
      .drawRoundedRect(0, 0, this.#width, this.#height, this.#radius)
      .endFill();

    this.#segmentGraphics.clear();

    const innerW = this.#width - this.#padding * 2;
    const segCount = this.#segments;
    const segW = (innerW - this.#gap * (segCount - 1)) / segCount;

    const filled = Math.floor(this.#health * segCount);

    for (let i = 0; i < segCount; i++) {
      const x = this.#padding + i * (segW + this.#gap);
      const y = i === 0 || i === segCount - 1 ? 1 : 0;
      const innerH = i === 0 || i === segCount - 1 ? this.#height - 2 : this.#height;

      if (i < filled) {
        this.#segmentGraphics.beginFill(color, 1).drawRoundedRect(x, y, segW, innerH, 2).endFill();
        if (i === 0) {
          this.#segmentGraphics
            .beginFill(color, 1)
            .drawRoundedRect(x - 1, y + 3, segW, innerH - 3, 3)
            .endFill();
        }
        if (i === segCount - 1) {
          this.#segmentGraphics
            .beginFill(color, 1)
            .drawRoundedRect(x + 1, y + 3, segW, innerH - 3, 3)
            .endFill();
        }
      }
    }
  }
}
